import { useEffect, useState } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addStatus } from '../../services/Other/GeneralQueries';

function AddItemStatusModal({ show, handleClose, handleReload }) {
  const [statusName, setStatusName] = useState('');

  useEffect(() => {
    if (show) setStatusName('');
  }, [show]);

  const handleAddStatus = async () => {
    if (!statusName.trim()) {
      toast.warning('Lo sentimos, debes completar el campo: Estados');
      return;
    }

    const res = await addStatus(statusName.trim());
    if (!res?.result) {
      toast.error(res?.message ?? 'No se pudo crear el estados.');
      return;
    }

    toast.success('Estados creado correctamente');
    handleClose();
    handleReload();
  };

  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Agregar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12} className="p-2">
            <Form.Label>Nombre:</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nombre del estado"
              value={statusName}
              onChange={(e) => setStatusName(e.target.value)}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleAddStatus}>
          Guardar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddItemStatusModal;